import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../redux/features/modalSlice';
import { useUpdateGotraMutation } from '../../redux/services/gotraService/gotra.Services';
import { successToast, errorToast } from '../../Utils/toast';

function EditGotra({ data }) {
  const dispatch = useDispatch();
  const [updateGotra, { isLoading }] = useUpdateGotraMutation();
  
  const [formData, setFormData] = useState({
    gotra_name: '',
    status: 'active',
  });

  useEffect(() => {
    if (data) {
      setFormData({
        gotra_name: data.gotra_name || data.name || '',
        status: data.status || 'active',
      });
    }
  }, [data]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.gotra_name.trim()) {
      errorToast('Error', 'Gotra name is required');
      return;
    }

    try {
      const payload = {
        id: data.id,
        gotra_name: formData.gotra_name,
        status: formData.status,
      };

      await updateGotra(payload).unwrap();
      successToast('Success', 'Gotra updated successfully');
      dispatch(closeModal());
      window.location.reload();
    } catch (error) {
      console.error('Update error:', error);
      errorToast('Error', error?.data?.message || 'Failed to update gotra');
    }
  };

  return (
    <div className="edit-gotra-container">
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label fw-bold">
            Gotra Name <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="gotra_name"
            value={formData.gotra_name}
            onChange={handleChange}
            placeholder="Enter gotra name"
            required
            autoFocus
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">Status</label>
          <select
            className="form-control"
            name="status"
            value={formData.status}
            onChange={handleChange}
          >
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>

        <div className="d-flex justify-content-end gap-2 mt-4">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => dispatch(closeModal())}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" />
                Saving...
              </>
            ) : (
              'Save Changes'
            )}
          </button>
        </div>
      </form>
    </div>
  );
}

export default EditGotra;